import { render, staticRenderFns } from "./bankRecordsList.vue?vue&type=template&id=f7c5d682&scoped=true&"
import script from "./bankRecordsList.vue?vue&type=script&lang=js&"
export * from "./bankRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./bankRecordsList.vue?vue&type=style&index=0&id=f7c5d682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c5d682",
  null
  
)

export default component.exports